/** Every legal ordered build: two distinct Tier 1 branches, then one of their Tier 2s. */
export const VETERAN_DEVELOPMENT_PATHS = {
    VETERAN_ATTACK_DEFENCE_ATTACK: ['attack_1', 'defence_1', 'attack_2'],
    VETERAN_ATTACK_DEFENCE_DEFENCE: ['attack_1', 'defence_1', 'defence_2'],
    VETERAN_DEFENCE_ATTACK_ATTACK: ['defence_1', 'attack_1', 'attack_2'],
    VETERAN_DEFENCE_ATTACK_DEFENCE: ['defence_1', 'attack_1', 'defence_2'],
    VETERAN_ATTACK_COMMAND_ATTACK: ['attack_1', 'command_1', 'attack_2'],
    VETERAN_ATTACK_COMMAND_COMMAND: ['attack_1', 'command_1', 'command_2'],
    VETERAN_COMMAND_ATTACK_ATTACK: ['command_1', 'attack_1', 'attack_2'],
    VETERAN_COMMAND_ATTACK_COMMAND: ['command_1', 'attack_1', 'command_2'],
    VETERAN_DEFENCE_COMMAND_DEFENCE: ['defence_1', 'command_1', 'defence_2'],
    VETERAN_DEFENCE_COMMAND_COMMAND: ['defence_1', 'command_1', 'command_2'],
    VETERAN_COMMAND_DEFENCE_DEFENCE: ['command_1', 'defence_1', 'defence_2'],
    VETERAN_COMMAND_DEFENCE_COMMAND: ['command_1', 'defence_1', 'command_2'],
};
export const VETERAN_DEVELOPMENT_SKILLS = Object.keys(VETERAN_DEVELOPMENT_PATHS);
export const VETERAN_DEVELOPMENT_LABELS = Object.fromEntries(VETERAN_DEVELOPMENT_SKILLS.map((skill) => [skill, `Veteran (${VETERAN_DEVELOPMENT_PATHS[skill].map((id) => {
        const branch = id.split('_')[0];
        return branch[0].toUpperCase() + branch.slice(1) + (id.endsWith('_2') ? ' II' : ' I');
    }).join(' → ')})`]));
export function veteranDevelopmentPath(skill) {
    return Object.hasOwn(VETERAN_DEVELOPMENT_PATHS, skill)
        ? VETERAN_DEVELOPMENT_PATHS[skill] : undefined;
}
//# sourceMappingURL=botDevelopment.js.map